module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/bucknell-university-d0e393b4555f0fec81a2e98cdef252dd.jpg";